import axios from 'axios'
import fileDownload from 'js-file-download'
import React from 'react'
import { useEffect } from 'react'
import { Button, Col, Modal, Table } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import Dropzone from 'react-dropzone'
import XLSX from 'xlsx'

import { urlApiNewPy } from '../../shared/helpers/api/urls'

import { urlMyspreadApi } from '@apis/urls';
import { basicAuthConfig } from '@apis/configs';

export const ZeoFiles = ({ path, title, loading, setLoading }) => {
    const [region, setRegion] = React.useState('')
    const [archivos, setArchivos] = React.useState([])
    const [hayCarriles, setHayCarriles] = React.useState(false)
    const [estimadosCarriles, setEstimadosCarriles] = React.useState([])
    const [dinamicaCarriles, setDinamicaCarriles] = React.useState([{}])
    const [dinamicaCarriles_fix, setDinamicaCarriles_fix] = React.useState([{}])
    const [driverCarriles, setDriverCarriles] = React.useState([{}])
    const [dinamicaComunas, setDinamicaComunas] = React.useState([{}])
    const [lastMileZeoFile, setLastMileZeoFile] = React.useState('')
    // Estado para manejar el tipo de selección por carril (conductor o dirección)
    const [tipoSeleccionCarriles, setTipoSeleccionCarriles] = React.useState({})
    const { user: currentUser } = useSelector(state => state.auth)

    useEffect(() => {
        setRegion('')
    }, [path])

    useEffect(() => {
        setArchivos([])
        setHayCarriles(false)
        setDinamicaCarriles([{}])
        setDinamicaComunas([{}])
        setLastMileZeoFile('')
        setEstimadosCarriles([])
        setTipoSeleccionCarriles({})
    }, [region])

    const [showModal, setShowModal] = React.useState(false);
    const [initialNumber, setInitialNumber] = React.useState(1);

    const handleModalOpen = () => {
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleNumberChange = (e) => {
        setInitialNumber(parseInt(e.target.value));
    };

    const saveInitialNumber = () => {
        // Perform any necessary logic with the initialNumber value
        // ...
        handleModalClose();
    };

    // TODO - Refactor this function to a helper file
    const handleDownloadBlobFile = (url, filename) => {
        axios.get(url, {
            responseType: 'blob',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
            }
        })
            .then((res) => {
                fileDownload(res.data, filename)
            })
    }

    const showRegionsButtons = () => {
        return (
            <div align='center'>
                <table width={'60%'}>
                    <tbody>
                        <tr>
                            <td align='center'>
                                <Button
                                    className='mt-2 spread-font btn btn-primary'
                                    variant="contained"
                                    style={{ backgroundColor: 'rgb(0, 155, 120)', color: 'white' }}
                                    onClick={() => { handlerRegion('SCL') }}
                                    value="Metropolitana"
                                >
                                    Metropolitana
                                </Button>
                            </td>
                            <td align='center'>
                                <Button
                                    className='mt-2 spread-font btn btn-primary'
                                    variant="contained"
                                    style={{ backgroundColor: 'rgb(0, 155, 120)', color: 'white' }}
                                    onClick={() => { handlerRegion('VAP') }}
                                    value="Valparaiso"
                                >
                                    Valparaiso
                                </Button>
                            </td>
                            <td align='center'>
                                <Button
                                    className='mt-2 spread-font btn btn-primary'
                                    variant="contained"
                                    style={{ backgroundColor: 'rgb(0, 155, 120)', color: 'white' }}
                                    onClick={() => { handlerRegion('QRC') }}
                                    value="O'Higgins"
                                >
                                    O'Higgins
                                </Button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

    const handlerRegion = async (region) => {
        setLoading(true)

        if (path === 'generacionZeo') {
            setRegion(region)
            console.log('creando archivos ZEO para la region: ', region);

            let url = urlMyspreadApi + 'planificacion/armadoZeo'

            const data = {
                "region": region,
                "user": currentUser.email
            }

            const basicAuth = basicAuthConfig(currentUser)

            const config = {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                    'Content-Type': 'application/json',
                    ...basicAuth.headers
                }
            }

            await axios.post(url, data, config)
                .then((res) => {
                    // https://stprocesosdiarios.blob.core.windows.net/myspread/archivos_zeo/SCL_2024-05-10_17_41.zip
                    if (res.status === 200) {
                        // console.log('res.data: ', res.data);
                        let url_zip = `https://stprocesosdiarios.blob.core.windows.net/myspread/archivos_zeo/${res.data.nombre_archivo}.zip`
                        try {
                            handleDownloadBlobFile(url_zip, res.data.nombre_archivo + '.zip')
                            setLoading(false)
                            Swal.fire({
                                icon: 'success',
                                title: 'Archivos ZEO generados',
                                text: 'Los archivos ZEO han sido generados correctamente',
                                showConfirmButton: true,
                            })
                        } catch (error) {
                            setLoading(false)
                            const errorMessage = error.response?.data?.msg || error.response?.data?.error || 'Ha ocurrido un error al intentar generar los archivos ZEO';
                            Swal.fire({
                                icon: 'error',
                                title: 'Error al generar archivos ZEO',
                                text: errorMessage,
                                showConfirmButton: true,
                            })
                        }
                    }
                })
                .catch((error) => {
                    console.error('error: ', error.response.data);
                    setLoading(false)
                    const errorMessage = error.response?.data?.msg || error.response?.data?.error || 'Ha ocurrido un error al intentar generar los archivos ZEO';
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al generar archivos ZEO',
                        text: errorMessage,
                        showConfirmButton: true,
                    })
                })
            setRegion('')
        }

        if (path === 'generarLastMile') {
            setRegion(region)
            console.log('generarLastMile para la region: ', region);
            setLoading(false)
        }
    }

    const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
    });

    const handleFileUpload = async (files) => {
        const validFiles = files.filter(file => file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        if (validFiles.length === files.length) {
            // All files are xlsx

            let allFiles = [...archivos]
            files.forEach(async (file) => {
                allFiles.push(file)
            })
            setArchivos(allFiles)

        } else {
            // Not all files are xlsx
            Swal.fire({
                icon: 'error',
                title: 'Error al subir archivos',
                text: 'Solo se permiten archivos Excel (.xlsx)',
                showConfirmButton: true,
            })
        }
        // console.log('files: ', files);
    }

    const countRowsInExcel = (file, log) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                let guias = 0
                const data = e.target.result
                const workbook = XLSX.read(data, { type: 'binary' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                rows.forEach(row => {
                    if (log) {
                        console.log('row: ', row[0]);
                    }
                    if (row[0] !== undefined && row[0] !== '' && row[0] !== ' ') {
                        if (log) {
                            console.log('row post: ', row[0]);
                        }
                        guias++
                    }
                })
                guias = guias - 1
                resolve(guias);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsBinaryString(file);
        });
    };

    const excelToJson = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = e.target.result
                const workbook = XLSX.read(data, { type: 'binary' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                resolve(rows);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsBinaryString(file);
        });
    }


    const processFiles = async (files) => {
        setLoading(true);

        const headersLastMile = ['SUBITEM', 'NÚMERO GUÍA', 'VEHÍCULO', 'NOMBRE ITEM', 'CANTIDAD', 'CODIGO ITEM', 'IDENTIFICADOR CONTACTO', 'NOMBRE CONTACTO', 'TELEFONO', 'EMAIL CONTACTO', 'DIRECCIÓN', 'LATITUD', 'LONGITUD', 'FECHA MIN ENTREGA', 'FECHA MAX ENTREGA', 'CT DESTINO', 'GRUPOS - Clientes', 'ClientNames', 'CLIENTES', 'COMUNA', 'REGION', 'RECEPCION FISICA', 'FECHA COMPROMISO', 'TAMAÑO PRODUCTO', 'f12', 'viaje trl', 'rh', 'numcorhr', 'id_dispatch_paris', 'id_route_paris', 'cud_ripley', 'oc_ripley', 'id_appolo', 'n_clientes', 'pyme', 'LOCAL DE ABASTECIMIENTO CLIENTE', 'TAMAÑO SPREAD', 'SERVICIO SPREAD', 'RADIO', 'CENTRO DESPACHO BT', 'MES OPERATIVO', 'CARRIL']
        const headersZeo = ['Serial No', 'Address', 'Distance ( From Start)', 'Original ETA', 'Updated ETA', 'Actual Arrived at time', 'Distance Difference Between Stops', 'Time Difference Between Stops', 'Stop Progress', 'Stop Progress Reason', 'Latitude', 'Longitude', 'Pickup Stop', 'Note', 'Order Number', 'Customer Name', 'Customer Mobile', 'Customer Email', 'Delivery Notes', 'Signature Proof', 'Delivery Proof', 'Payment Type', 'Cash Amount', 'POD Payment Note', 'Payment Photo URL', 'Box Picture', 'Parcel Count', 'Place in Vehicle', 'Stop Start Time', 'Stop end time', 'Stop Type', 'Stop Duration', 'Navigate Start', 'Done Latitude', 'Done Longitude', 'Street', 'Locality', 'City', 'State', 'Country', 'Zip Code', 'Route Name', 'Start Time', 'Driver Email']
        const headersZeoEsp = ['Número de serie', 'DIRECCIÓN', 'Distancia (desde el inicio)', 'hora estimada de llegada original', 'ETA actualizada', 'Real Llegó a la hora', 'Diferencia de distancia entre paradas', 'Diferencia horaria entre paradas', 'Detener el progreso', 'Razón para detener el progreso', 'Latitud', 'Longitud', 'Parada de recogida', 'Nota', 'Número de orden', 'Nombre del cliente', 'Móvil del cliente', 'Correo electrónico del cliente', 'Albaranes de entrega', 'Prueba de firma', 'Prueba de entrega', 'Tipo de pago', 'Monto en efectivo', 'Nota de pago POD', 'URL de la foto de pago', 'Imagen de caja', 'Recuento de paquetes', 'Colocar en el vehículo', 'Hora de inicio de parada', 'detener la hora de finalización', 'Tipo de parada', 'Duración de la parada', 'Navegar Inicio', 'Listo Latitud', 'Hecho Longitud', 'Calle', 'Localidad', 'Ciudad', 'Estado', 'País', 'Código postal', 'Nombre de la ruta', 'Hora de inicio', 'Correo electrónico del conductor']

        let LastMileFile = []
        let zeoFile = []
        let errorFiles = []

        for (const file of files) {
            const data = await excelToJson(file);

            const rowData = Object.values(data[0]);
            if (rowData.length === headersLastMile.length && rowData.every((value, index) => value === headersLastMile[index])) {
                // data.shift();
                // LastMileFile = LastMileFile.concat(data);
                LastMileFile.push(file)
            } else if (rowData.length === headersZeo.length && rowData.every((value, index) => value === headersZeo[index])) {
                // data.shift();
                // zeoFile = zeoFile.concat(data);
                zeoFile.push(file)
            } else if (rowData.length === headersZeoEsp.length && rowData.every((value, index) => value === headersZeoEsp[index])) {
                zeoFile.push(file)
            } else {
                errorFiles.push(file);
            }

        }

        if (errorFiles.length > 0) {
            let nombre = ''
            for (const file of errorFiles) {
                nombre += file.name + ' - \n'
            }
            Swal.fire({
                icon: 'error',
                title: 'Error al subir archivos',
                text: 'Los siguientes archivos no tienen el formato correcto: \n' + nombre,
                showConfirmButton: true,
            })
            setLoading(false)
            return
        } else if (LastMileFile.length === 0) {
            Swal.fire({
                icon: 'error',
                title: 'Error al subir archivos',
                text: 'No se encontro el archivo con el formato correcto de LastMile',
                showConfirmButton: true,
            })
            setLoading(false)
            return
        } else if (zeoFile.length === 0) {
            Swal.fire({
                icon: 'error',
                title: 'Error al subir archivos',
                text: 'No se encontro el archivo con el formato correcto de ZEO',
                showConfirmButton: true,
            })
            setLoading(false)
            return
        } else if (LastMileFile.length > 1) {
            Swal.fire({
                icon: 'error',
                title: 'Error al subir archivos',
                text: 'Solo se permite un archivo de LastMile',
                showConfirmButton: true,
            })
            setLoading(false)
            return
        }

        const conteoLastMile = await countRowsInExcel(LastMileFile[0])
        let conteoZeo = 0
        for (const file of zeoFile) {
            conteoZeo += await countRowsInExcel(file)
        }

        if (conteoLastMile !== conteoZeo) {
            Swal.fire({
                icon: 'error',
                title: 'Error al subir archivos',
                text: 'La cantidad de registros en los archivos ZEO y LastMile no coinciden',
                showConfirmButton: true,
            })
            setLoading(false)
            return
        }

        let url = urlMyspreadApi + 'planificacion/armadoLastMileFromZeo'

        const sendFilesToBackend = async () => {
            // try {
            const formData = new FormData();
            const name_lastMile_file = 'lastMileFile_' + region
            formData.append(name_lastMile_file, LastMileFile[0]);
            zeoFile.forEach((file, index) => {
                formData.append(`zeoFile${index}`, file);
            });

            const basicAuth = basicAuthConfig(currentUser)

            await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    ...basicAuth.headers
                },
            })
                .then((res) => {
                    // console.log('res: ', res);
                    if (res.status === 200) {
                        setLastMileZeoFile(res.data.archivo_correcto)
                        setDinamicaCarriles(res.data.orden_carriles)
                        setDinamicaCarriles_fix(res.data.orden_carriles)
                        setDinamicaComunas(res.data.orden_comunas)
                        setHayCarriles(true)
                        setLoading(false);
                        Swal.fire({
                            icon: 'success',
                            title: 'Archivos ZEO procesados correctamente',
                            text: 'Archivos para continuar se han procesado correctamente',
                            showConfirmButton: true,
                        });
                    } else {
                        setLoading(false);
                        throw new Error('Error uploading files');
                    }
                })
                .catch((error) => {
                    console.log('error: ', error.response.data);
                    setLoading(false);
                    const errorMessage = error.response?.data?.msg || error.response?.data?.error || 'Ha ocurrido un error al intentar subir los archivos';
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al subir archivos',
                        text: errorMessage,
                        showConfirmButton: true,
                    });
                })
        };

        await sendFilesToBackend();
    }

    const handleMixCarriles = async (e) => {
        // console.log(e.target.value);
        if (e.target.value === '') return;
        const carriles = e.target.value.split(',');
        const direcciones1 = dinamicaCarriles_fix.find(carril => carril[0] === carriles[0]);
        const direcciones2 = dinamicaCarriles_fix.find(carril => carril[0] === carriles[1]);
        const mixedCarril = `${direcciones1[0]}-${direcciones2[0]}`;
        const sumDirecciones = parseInt(direcciones1[1]) + parseInt(direcciones2[1]);
        const sumItems = parseInt(direcciones1[2]) + parseInt(direcciones2[2]);
        const newCarril = [mixedCarril, sumDirecciones, sumItems];

        // setCarrilesRespaldo([...carrilesRespaldo, carril1, carril2]);

        const updatedCarriles = dinamicaCarriles_fix.filter(carril => carril[0] !== carriles[0] && carril[0] !== carriles[1]);
        updatedCarriles.push(newCarril);
        setDinamicaCarriles_fix(updatedCarriles);
        setEstimadosCarriles([]);
    }

    const handleSeparateCarriles = async (e) => {
        const carriles = e.split('-')

        let nuevosCarriles = []
        carriles.map((carrilSeparado, index) => {
            const nuevosCarril = dinamicaCarriles.find(carril => carril[0] === carrilSeparado)
            nuevosCarriles.push(nuevosCarril)
        })
        const updatedCarriles = dinamicaCarriles_fix.filter(carril => carril[0] !== e)
        nuevosCarriles.map((nuevoCarril) => {
            updatedCarriles.push(nuevoCarril)
        })
        setDinamicaCarriles_fix(updatedCarriles)
        setEstimadosCarriles([]);
    }

    const handleNumberDrivers = async (e, carril, direcciones, guias) => {
        const valorIngresado = parseInt(e.target.value);
        const tipoSeleccion = tipoSeleccionCarriles[carril] || 'conductor';
        
        // Validaciones
        if (valorIngresado < 1) {
            e.target.value = 1;
            return;
        }
        
        if (tipoSeleccion === 'direccion' && valorIngresado > direcciones) {
            e.target.value = direcciones;
            return;
        }

        const newEstimadosCarriles = estimadosCarriles.filter(estimado => estimado.carril !== carril)
        setEstimadosCarriles([
            ...newEstimadosCarriles, 
            { 
                carril: carril, 
                conductores: valorIngresado,
                tipo_seleccion: tipoSeleccion,
                total_direcciones: direcciones,
                total_guias: guias
            }
        ])
    }

    // Nueva función para cambiar el tipo de selección
    const handleTipoSeleccion = (carril, nuevoTipo) => {
        setTipoSeleccionCarriles({
            ...tipoSeleccionCarriles,
            [carril]: nuevoTipo
        });
        
        // Limpiar el valor actual del carril en estimados
        const newEstimadosCarriles = estimadosCarriles.filter(estimado => estimado.carril !== carril)
        setEstimadosCarriles(newEstimadosCarriles)
    }

    // Funciones helper para cálculos
    const calcularConductoresEstimados = (carril, direcciones, valorIngresado) => {
        const tipoSeleccion = tipoSeleccionCarriles[carril] || 'conductor';
        const estimado = estimadosCarriles.find(e => e.carril === carril);
        
        if (!estimado || estimado.conductores === 0) return 0;
        
        if (tipoSeleccion === 'conductor') {
            return estimado.conductores;
        } else {
            // Modo dirección: calcular conductores necesarios
            return Math.ceil(direcciones / estimado.conductores);
        }
    }

    const calcularEstimacionDirecciones = (carril, direcciones) => {
        const tipoSeleccion = tipoSeleccionCarriles[carril] || 'conductor';
        const estimado = estimadosCarriles.find(e => e.carril === carril);
        
        if (!estimado || estimado.conductores === 0) return 0;
        
        if (tipoSeleccion === 'conductor') {
            // Modo conductor: dividir direcciones entre conductores
            return Math.ceil(direcciones / estimado.conductores);
        } else {
            // Modo dirección: el máximo seleccionado
            return estimado.conductores;
        }
    }

    const calcularEstimacionGuias = (carril, direcciones, guias) => {
        const tipoSeleccion = tipoSeleccionCarriles[carril] || 'conductor';
        const estimado = estimadosCarriles.find(e => e.carril === carril);
        
        if (!estimado || estimado.conductores === 0) return 0;
        
        if (tipoSeleccion === 'conductor') {
            // Modo conductor: dividir guías entre conductores
            return Math.ceil(guias / estimado.conductores);
        } else {
            // Modo dirección: calcular conductores y dividir guías
            const conductoresEstimados = Math.ceil(direcciones / estimado.conductores);
            return Math.ceil(guias / conductoresEstimados);
        }
    }

    const modalNumeroInicial = () => {
        return (
            <>
                {showModal && (
                    <>
                        {/* <button className='btn btn-primary' onClick={handleModalOpen}>
                            Set Initial Number
                        </button> */}
                        <div className='modal'>
                            <div className='modal-content'>
                                <h3>Set Initial Number</h3>
                                <input type='number' value={initialNumber} onChange={handleNumberChange} />
                                <button className='btn btn-success' onClick={saveInitialNumber}>
                                    Save
                                </button>
                                <button className='btn btn-danger' onClick={handleModalClose}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    };

    const saveEstimados = async () => {
        // console.log(archivoCorrecto, archivoError);
        let data = {}
        let url = urlMyspreadApi + 'planificacion/armadoLastMileDes'

        setLoading(true)
        handleModalClose()

        if (dinamicaCarriles_fix.length === estimadosCarriles.length) {
            // Formatear los estimados según el tipo de selección
            const estimadosFormateados = estimadosCarriles.map(estimado => {
                const tipoSeleccion = estimado.tipo_seleccion || 'conductor';
                
                if (tipoSeleccion === 'conductor') {
                    // Modo conductor: mantener estructura actual
                    return {
                        carril: estimado.carril,
                        tipo_seleccion: 'conductor',
                        cantidad_conductores: estimado.conductores
                    };
                } else {
                    // Modo dirección: nueva estructura
                    return {
                        carril: estimado.carril,
                        tipo_seleccion: 'direccion',
                        cantidad_maxima_direcciones: estimado.conductores
                    };
                }
            });

            data = {
                region: region,
                archivo_correcto: lastMileZeoFile,
                estimados: estimadosFormateados,
                tabla_carriles: dinamicaCarriles_fix,
                folder: "archivos_LastMile_zeo",
                numInicial: initialNumber,
            }

            const basicAuth = basicAuthConfig(currentUser)

            const config = {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                    'Content-Type': 'application/json',
                    ...basicAuth.headers
                }
            }

            await axios.post(url, data, config)
                .then((response) => {
                    const archivo = response.data.archivo_correcto
                    const folder = response.data.folder
                    const container = response.data.container
                    // https://stprocesosdiarios.blob.core.windows.net/myspread/archivos_LastMile/SCL_2024-04-01_09_41_LastMile.xlsx
                    const url = `https://stprocesosdiarios.blob.core.windows.net/${container}/${folder}/${archivo}`
                    try {
                        handleDownloadBlobFile(url, archivo)
                        Swal.fire({
                            title: 'Éxito',
                            icon: 'success',
                            text: 'Archivo generado exitosamente',
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#009B78',
                            showDenyButton: false,
                            customClass: {
                                confirmButton: 'spread-font spread-width-100'
                            }
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location.reload()
                            } else {
                                window.location.href = '/planning'
                            }
                        })
                    } catch (error) {
                        console.log(error);
                        Swal.fire({
                            title: 'Error',
                            icon: 'error',
                            text: 'Hubo un problema al descargar el archivo, favor contactar a TI',
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#009B78',
                            showDenyButton: false,
                            customClass: {
                                confirmButton: 'spread-font spread-width-100'
                            }
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location.reload()
                            } else {
                                window.location.href = '/planning'
                            }
                        })
                    }
                    setLoading(false)
                    // console.log(response);
                })
                .catch((error) => {
                    setLoading(false)
                    console.log(error.response.data.msg);
                    Swal.fire({
                        title: 'Error',
                        icon: 'error',
                        text: 'Hubo un problema al generar el archivo, favor contactar a TI',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#009B78',
                        showDenyButton: false,
                        customClass: {
                            confirmButton: 'spread-font spread-width-100'
                        }
                    })
                })
        } else {
            // console.log("The lengths are not equal");
            setLoading(false)
            Swal.fire({
                title: 'Error',
                icon: 'error',
                text: 'Debe ingresar la cantidad de conductores para todos los carriles',
                confirmButtonText: 'OK',
                confirmButtonColor: '#009B78',
                showDenyButton: false,
                customClass: {
                    confirmButton: 'spread-font spread-width-100'
                }
            })

        }
    }

    return (
        <>
            <Col className='text-center align-self-center justify-content-md-center' style={{ margin: "10px" }}>
                {/* {region !== '' && <h3>Generar Last Mile para la región {region} desde archivos ZEO</h3>} */}
                {
                    path === 'generacionZeo' &&
                    <>
                        {
                            region === '' && (
                                showRegionsButtons()
                            )
                        }
                    </>
                }
                {
                    path === 'generarLastMile' &&
                    <>
                        {
                            region === '' && !hayCarriles &&
                            showRegionsButtons()
                        }
                        {
                            region !== '' && !hayCarriles &&
                            <>
                                <div style={{ display: 'flex', justifyContent: 'space-between', width: '80%', margin: 'auto' }}>
                                    {/* <h3>Región: {region}</h3> */}
                                    <h3>Subir archivos ZEO para la región {region}</h3>
                                    <button
                                        className='btn btn-secondary'
                                        onClick={() => setRegion('')}
                                    >
                                        Volver
                                    </button>
                                </div>
                                <hr />

                                <Dropzone onDrop={handleFileUpload} multiple>
                                    {({ getRootProps, getInputProps }) => (
                                        <div {...getRootProps()}
                                            style={{
                                                width: '100%',
                                                height: '100px',
                                                border: '1px solid lightgray',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            <input {...getInputProps()} />
                                            <p>Puedes arrastrar los archivos a esta casilla o presionar para seleccionar los archivos</p>
                                        </div>
                                    )}
                                </Dropzone>
                            </>
                        }
                        {
                            archivos.length > 0 && !hayCarriles &&
                            <>
                                <br></br><h4>Archivos Subidos</h4>
                                <table width={'60%'} style={{ margin: '0 auto' }}>
                                    <thead>
                                        <tr>
                                            <th>Archivo</th>
                                            <th>Eliminar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {archivos.map((file, index) => (
                                            <tr key={index}>
                                                <td>{file.name}</td>
                                                <td>
                                                    <Button
                                                        className='spread-font btn btn-danger'
                                                        variant="contained"
                                                        style={{ backgroundColor: 'rgb(255, 46, 46)', color: 'white' }}
                                                        onClick={() => {
                                                            const newFiles = archivos.filter((f, i) => i !== index);
                                                            setArchivos(newFiles);
                                                        }}
                                                    >
                                                        Eliminar
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <Button
                                    className='mt-2 spread-font btn btn-primary'
                                    variant="contained"
                                    style={{ backgroundColor: 'rgb(0, 155, 120)', color: 'white' }}
                                    onClick={() => processFiles(archivos)}
                                >
                                    Procesar planificación
                                </Button>
                            </>
                        }
                        {
                            hayCarriles &&
                            <>
                                <Modal
                                    show={showModal}
                                    onHide={handleModalClose}
                                    size="lg"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title>Configurar número de patente inicial</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <input type='number' value={initialNumber} onChange={handleNumberChange} />
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleModalClose}>
                                            Cancel
                                        </Button>
                                        <Button variant="primary" onClick={saveEstimados}>
                                            Save
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                                <div style={{ display: 'flex', justifyContent: 'space-between', width: '80%', margin: 'auto' }}>
                                    {/* <h3>Región: {region}</h3> */}
                                    <h3>Procesar carga para: {region}</h3>
                                    <button
                                        className='btn btn-secondary'
                                        onClick={() => setRegion('')}
                                    >
                                        Volver a seleccionar región
                                    </button>
                                </div>
                                <hr />
                                {/* Contenedor con scroll solo para la tabla */}
                                <div style={{ 
                                    display: 'flex', 
                                    flexDirection: 'column', 
                                    alignItems: 'center',
                                    maxHeight: 'calc(100vh - 350px)',
                                    width: '90%',
                                    margin: '0 auto'
                                }}>
                                    {/* Contenedor scrolleable para la tabla */}
                                    <div style={{ 
                                        overflowY: 'auto',
                                        overflowX: 'auto',
                                        width: '100%',
                                        maxHeight: 'calc(100vh - 300px)',
                                        marginBottom: '20px'
                                    }}>
                                        <Table striped bordered hover size="sm" style={{ width: '100%', margin: '0' }}>
                                            <thead style={{
                                                position: 'sticky',
                                                top: 0,
                                                backgroundColor: '#fff',
                                                zIndex: 10,
                                                boxShadow: '0 2px 2px -1px rgba(0, 0, 0, 0.1)'
                                            }}>
                                            <tr>
                                                <td align="center">Tipo</td>
                                                <td align="center">Carriles</td>
                                                <td align="center">Direcciones</td>
                                                <td align="center">Guías</td>
                                                <td align="center">Cantidad Máxima</td>
                                                <td align="center">Conductores Estimados</td>
                                                <td align="center">Estimación Direcciones</td>
                                                <td align="center">Estimación Guías</td>
                                                <td align="center">Juntar con carriles</td>
                                                <td align="center">Separar carriles</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                dinamicaCarriles_fix.map((value, index) => {
                                                    const tipoSeleccion = tipoSeleccionCarriles[value[0]] || 'conductor';
                                                    return (
                                                        <tr key={index}>
                                                            {/* Columna Tipo */}
                                                            <td align="center">
                                                                <select
                                                                    value={tipoSeleccion}
                                                                    onChange={(e) => handleTipoSeleccion(value[0], e.target.value)}
                                                                    style={{ 
                                                                        padding: '4px 8px',
                                                                        fontSize: '13px',
                                                                        borderRadius: '4px',
                                                                        border: '1px solid #ccc'
                                                                    }}
                                                                >
                                                                    <option value="conductor">👤 Conductor</option>
                                                                    <option value="direccion">📍 Dirección</option>
                                                                </select>
                                                            </td>
                                                            {/* Columna Carril */}
                                                            <td align="center">{value[0]}</td>
                                                            {/* Columna Direcciones */}
                                                            <td align="center">{value[1]}</td>
                                                            {/* Columna Guías */}
                                                            <td align="center">{value[2]}</td>
                                                            {/* Columna Cantidad Máxima (editable) */}
                                                            <td align="center">
                                                                <input
                                                                    type="number"
                                                                    min={1}
                                                                    max={tipoSeleccion === 'direccion' ? value[1] : undefined}
                                                                    onChange={(e) => handleNumberDrivers(e, value[0], value[1], value[2])}
                                                                    required
                                                                    value={
                                                                        estimadosCarriles.filter(estimado => estimado.carril === value[0]).length > 0
                                                                            ? estimadosCarriles.filter(estimado => estimado.carril === value[0])[0].conductores
                                                                            : 0
                                                                    }
                                                                    style={{
                                                                        width: '80px',
                                                                        padding: '4px',
                                                                        textAlign: 'center'
                                                                    }}
                                                                    title={tipoSeleccion === 'conductor' ? 'Cantidad de conductores' : 'Máximo de direcciones por conductor'}
                                                                />
                                                                <br />
                                                                <small style={{ fontSize: '10px', color: '#666' }}>
                                                                    {tipoSeleccion === 'conductor' ? 'Conductores' : 'Máx. Direcciones'}
                                                                </small>
                                                            </td>
                                                            {/* Columna Conductores Estimados */}
                                                            <td align="center" style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
                                                                {calcularConductoresEstimados(value[0], value[1], value[2])}
                                                            </td>
                                                            {/* Columna Estimación Direcciones */}
                                                            <td align="center">
                                                                {calcularEstimacionDirecciones(value[0], value[1])}
                                                            </td>
                                                            {/* Columna Estimación Guías */}
                                                            <td align="center">
                                                                {calcularEstimacionGuias(value[0], value[1], value[2])}
                                                            </td>
                                                            {/* Columna Juntar con carriles */}
                                                            <td align="center">
                                                                <select
                                                                    onChange={handleMixCarriles}
                                                                    defaultValue={''}
                                                                    value={''}
                                                                >
                                                                    <option value={''}></option>
                                                                    {dinamicaCarriles_fix.map((carril, index2) => (
                                                                        <>
                                                                            {
                                                                                (carril[0] !== value[0]) && (
                                                                                    <option key={index2} value={`${carril[0]},${value[0]}`}>
                                                                                        {carril[0]}
                                                                                    </option>
                                                                                )
                                                                            }
                                                                        </>
                                                                    ))}
                                                                </select>
                                                            </td>
                                                            <td align="center">
                                                                {
                                                                    (value[0].split('-').length > 1)
                                                                        ? (
                                                                            <button
                                                                                className='btn btn-danger'
                                                                                onClick={() => handleSeparateCarriles(value[0])}
                                                                            >
                                                                                Separar
                                                                            </button>
                                                                        )
                                                                        : ('')
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                                
                                {/* Botón Guardar fuera del scroll, siempre visible */}
                                <div style={{ 
                                    display: 'flex', 
                                    justifyContent: 'flex-end', 
                                    width: '100%',
                                    paddingRight: '20px',
                                    marginTop: '10px'
                                }}>
                                    <button
                                        className='btn btn-success'
                                        onClick={handleModalOpen}
                                        style={{
                                            fontSize: '16px',
                                            padding: '10px 30px',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Guardar
                                    </button>
                                </div>
                            </div>
                            </>
                        }
                    </>
                }
            </Col>
        </>
    )
}
